import { z } from 'zod';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const ip = z.union([z.ipv4(), z.ipv6()]);

export const BAN_DURATIONS = ['permanent', '1d', '7d', '30d', '90d'] as const;
export type BanDuration = (typeof BAN_DURATIONS)[number];

export const banSchema = z
  .object({
    target: z.enum(['visitor', 'ip']),
    visitorId: z.string().trim(),
    ip: z.string().trim(),
    reason: z.string().trim().max(300, { error: 'chatSettings:validation.max300' }),
    duration: z.enum(BAN_DURATIONS),
  })
  .superRefine((value, ctx) => {
    if (value.target === 'visitor' && !UUID.test(value.visitorId)) {
      ctx.addIssue({
        code: 'custom',
        path: ['visitorId'],
        message: 'chatSettings:validation.visitorId',
      });
    }
    if (value.target === 'ip' && !ip.safeParse(value.ip).success) {
      ctx.addIssue({ code: 'custom', path: ['ip'], message: 'chatSettings:validation.ip' });
    }
  });

export type BanForm = z.infer<typeof banSchema>;
